module.exports = __webpack_public_path__ + "static/media/mo.59c91c04.svg";